<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">

// if (!data.value) {
//   navigateTo("/login");
// }

// const session = useState<{ username?: string }>("session", () => {
//   return { username: data.value?.username };
// });
</script>
